// extracted by mini-css-extract-plugin
module.exports = {"spinnerBorder":"Spinner_spinnerBorder__H-2hT","spinner":"Spinner_spinner__27llg"};